@let contentEntry = content();

@if (isDiscovered() && contentEntry) {
  <app-tooltip-item-preview #preview [display]="displayTooltip()">
    @let qty = quantityOfMaterial();

    @if (qty > 0) {
      <div class="mt-2 type-meta">Quantity: {{ qty | number }}</div>
    }
  </app-tooltip-item-preview>

  <div [tp]="preview.template()" [tpPlacement]="'top'">
    <app-slot-rarity-outline
      [entry]="contentEntry"
      [spritesheet]="spritesheet()"
      [backdropSprite]="backdropSprite()"
    >
      <span text-banner-top>{{ reward().chance }}%</span>

      @if (rewardText(); as rewText) {
        <span badge-br>
          {{ rewText }}
        </span>
      }

      @if (rewardTextSmall(); as rewText) {
        <span text-banner-bottom>
          {{ rewText }}
        </span>
      }
    </app-slot-rarity-outline>
  </div>
} @else {
  <div [tp]="unknownTooltip()" [tpPlacement]="'top'">
    <app-icon-unknown />
  </div>
}
